<div class="loading-overlay" *ngIf="loading">
    <!-- show something fancy here, here with Angular 2 Material's loading bar or circle -->
    <img src="../assets/images/1x90.webp">
</div>
<router-outlet *ngIf="!loading"></router-outlet>